import CreditsPaymentDetailsTableMobile from './CreditsPaymentDetailsTableMobile';

export default CreditsPaymentDetailsTableMobile;
